// Remove trailing slash
export const normalizePathname = (pathname) => {
    if (!pathname) return "";
    
    if (pathname.endsWith("/")) return pathname.slice(0, -1);

    return pathname;
}

// Check if pathname is under base path
const isPathUnder = (pathname, base) => {
    return pathname === base || pathname.startsWith(`${base}/`);
}

// Mentor routes where the school year filter is disabled (doesn't support school years)
export const isSchoolYearDisabledRoute = (pathname) => {
    const normalizedPathname = normalizePathname(pathname);
    if (!normalizedPathname) return false;

    if (["/dashboard", "/mentor/planagenda", "/planagenda", "/toetsweek"].includes(normalizedPathname)) {
        return true;
    }
    if (isPathUnder(normalizedPathname, "/toets")) {
        return true;
    }
    if (isPathUnder(normalizedPathname, "/huiswerk")) {
        return true;
    }

    return false;
}
